import {
  UPDATED_GLOBAL_SUCCESS_MESSAGE,
  REMOVE_GLOBAL_SUCCESS_MESSAGE_IF_MATCHES_THIS_STRING
} from "../actions/globalSuccess";

import objectAssign from "object-assign";

import { globalSuccessInitialState } from "../state/initialState";

function globalSuccessReducer(state = globalSuccessInitialState, action) {
  let newStatus;
  switch (action.type) {
    case UPDATED_GLOBAL_SUCCESS_MESSAGE:
      newStatus = action.data;
      if (!action.data.animation) {
        newStatus.animation = null;
      }
      return objectAssign({}, state, newStatus);
    case REMOVE_GLOBAL_SUCCESS_MESSAGE_IF_MATCHES_THIS_STRING:
      if (
        state.message == action.data ||
        (action.data &&
          state.message.toLowerCase().includes(action.data.toLowerCase()))
      ) {
        newStatus = {
          message: ""
        };
      } else {
        newStatus = {};
      }

      return objectAssign({}, state, newStatus);
    default:
      return state;
  }
}

export default globalSuccessReducer;
